import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class BillingConceptEditService {
	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	loadBillingConcept(token, ID) {
		

		
		
		
		
		
		
		

		return this.http
			.get(this.apiUrl + "billingconcepts/v1/getcodbillingconcept/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

	}
	editBillingConcept(token, billingconcept: any) {
		

		
		
		
		
		
		
		

		return this.http
			.put(this.apiUrl + "billingconcepts/v1/updatebillingconcept", JSON.stringify(billingconcept), JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-concept/service/billing-concept-edit/billing-concept-edit.service.ts